export interface StatusInterface {
    id: number,
    option: string,
    bg_color: string,
}

const GetStatus = (status_id: number): StatusInterface => {

    const status = GetAllStatuses().filter((stat) => stat.id === status_id)

    return status.length === 1 ? status[0] : GetAllStatuses()[0]
}

const GetAllStatuses = (): Array<StatusInterface> => {

    return [
        {
            id: 1,
            option: 'Создан',
            bg_color: "#c1c1c1"
        },
        {
            id: 2,
            option: 'Утверждён',
            bg_color: "#99ccff"
        },
        {
            id: 3,
            option: 'Оплачен в аванс',
            bg_color: "#ffff99"
        },
        {
            id: 4,
            option: 'Частично оплачен',
            bg_color: "#ffcc66"
        },
        {
            id: 5,
            option: 'Оплачен',
            bg_color: "#CCFF66"
        },
        {
            id: 6,
            option: 'Отказан',
            bg_color: "#f37676"
        },
    ]

}

export default {
    getAll: GetAllStatuses,
    getStatus: GetStatus
}